module.exports = __webpack_public_path__ + "static/center-b0464209b3fa330d1f20f6dde0379fbe.png";